import { supabase } from '../lib/supabase';

// ---- Converters ----

const toVendorCamel = (row) => ({
  id: row?.id,
  name: row?.name,
  contactName: row?.contact_name || '',
  contactEmail: row?.contact_email || '',
  contactPhone: row?.contact_phone || '',
  companyAddress: row?.company_address || '',
  website: row?.website || '',
  types: row?.types || [],
  createdAt: row?.created_at,
  updatedAt: row?.updated_at,
});

const toVendorSnake = (c) => ({
  name: c?.name,
  contact_name: c?.contactName || null,
  contact_email: c?.contactEmail || null,
  contact_phone: c?.contactPhone || null,
  company_address: c?.companyAddress || null,
  website: c?.website || null,
  types: c?.types || [],
});

const toTypeCamel = (row) => ({
  id: row?.id,
  label: row?.label,
  sortOrder: row?.sort_order,
});

// ---- Vendors ----

export const getVendors = async () => {
  const { data, error } = await supabase?.from('vendors')?.select('*')?.order('name', { ascending: true });
  if (error) throw error;
  return (data || [])?.map(toVendorCamel);
};

export const createVendor = async (item) => {
  const { data, error } = await supabase?.from('vendors')?.insert(toVendorSnake(item))?.select()?.single();
  if (error) throw error;
  return toVendorCamel(data);
};

export const updateVendor = async (id, item) => {
  const { data, error } = await supabase?.from('vendors')?.update(toVendorSnake(item))?.eq('id', id)?.select()?.single();
  if (error) throw error;
  return toVendorCamel(data);
};

export const deleteVendor = async (id) => {
  const { error } = await supabase?.from('vendors')?.delete()?.eq('id', id);
  if (error) throw error;
};

// ---- Vendor Types ----

export const getVendorTypes = async () => {
  const { data, error } = await supabase?.from('vendor_types')?.select('*')?.order('sort_order', { ascending: true });
  if (error) throw error;
  return (data || [])?.map(toTypeCamel);
};

export const createVendorType = async (label) => {
  const { data: existing } = await supabase?.from('vendor_types')?.select('sort_order')?.order('sort_order', { ascending: false })?.limit(1);
  const sortOrder = existing?.length ? (existing?.[0]?.sort_order + 1) : 0;
  const { data, error } = await supabase?.from('vendor_types')?.insert({ label: label?.trim(), sort_order: sortOrder })?.select()?.single();
  if (error) throw error;
  return toTypeCamel(data);
};

export const updateVendorType = async (id, label) => {
  const { data, error } = await supabase?.from('vendor_types')?.update({ label: label?.trim() })?.eq('id', id)?.select()?.single();
  if (error) throw error;
  return toTypeCamel(data);
};

export const deleteVendorType = async (id) => {
  const { error } = await supabase?.from('vendor_types')?.delete()?.eq('id', id);
  if (error) throw error;
};
